import React, { useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import { isMasterUser } from "../helpers/masterUser";
import LoggedInLayout from "../layout";
import MasterLayout from "../layout/master/MasterLayout";

function AppLayout({ children }) {
	const { user } = useContext(AuthContext);

	if (isMasterUser(user)) {
		return <MasterLayout>{children}</MasterLayout>;
	}

	return <LoggedInLayout>{children}</LoggedInLayout>;
}

export default AppLayout;
